var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessDocumentRequest = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6667 29.5467V32C58.6634 37.7505 56.8014 43.3458 53.3583 47.9516C49.9152 52.5573 45.0755 55.9267 39.561 57.5571C34.0465 59.1876 28.1527 58.9918 22.7586 56.9989C17.3645 55.0061 12.7591 51.323 9.62927 46.4989C6.49942 41.6748 5.01282 35.9682 5.39118 30.2302C5.76954 24.4922 7.99259 19.0302 11.7288 14.6589C15.465 10.2876 20.5141 7.24106 26.1232 5.97377C31.7323 4.70647 37.6008 5.28628 42.8534 7.62671M58.6667 10.6667L32.0001 37.36L24.0001 29.36",
    stroke: "#25AC51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessDocumentRequest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success-document-request.33b4d185aa5cca51cf6b80272e18d289.svg";